<template>
  <div
    v-editable="blok"
    class="flex flex-col mx-auto max-w-screen-md"
  >
		<h3 class="text-3xl font-bold mt-20 mb-4">{{ blok.title }}</h3>
		<ul class="steps">
			<StoryblokComponent
				v-if="blok"
				v-for="blok in blok.list"
				:key="blok._uid"
				:blok="blok"
			/>
		</ul>
   
  </div>
</template>
 
<script setup>
defineProps({ blok: Object })

</script>
<style>
.steps li:nth-child(even) > .item-nr  {
	background-color: #4E1A90;
}	
.steps li:nth-child(even) > div > .text-block {
	color: rgba(255, 255, 255, 0.6) !important;
}	
</style>